import React from 'react'
import { useFieldArray, useWatch } from 'react-hook-form'
import { useSelector } from 'react-redux'
//UI
import { Card } from '@/components/Elements'
import { Input, VersionFileInput } from '@/components/Form'
import { Button, CloseButton, Flex, HStack, Text, VStack } from '@chakra-ui/react'

//Constant
import { OfferBookingDocumentTypes } from '@/features/offers/constants'
import { offerBookingGroupPolicyType } from '@/features/offers/constants/offerEditRights/offerBookingEditRights'
import { selectOfferPermissions } from '@/features/offers/slices/offerDetail.slice'
const BookingTabDocumentSection = () => {
  const offerPermissions = useSelector(selectOfferPermissions)

  const {
    fields: bookingSupportDocuments,
    append: addBookingSupportDocuments,
    remove: removeBookingSupportDocuments,
  } = useFieldArray({
    name: 'booking.supportDocuments',
    shouldUnregister: false,
  })

  const {
    fields: newAddedDocuments,
    append: addNewAddedDocuments,
    remove: removeNewAddedDocuments,
  } = useFieldArray({ name: 'booking.newSupportDocuments' })
  //Watcher
  const subSystems = useWatch({ name: 'subSystems' })
  const offerStatus = useWatch({ name: 'status' })

  //Permissions
  const canEditSupportDocuments = offerPermissions[offerBookingGroupPolicyType.BOOKING_SUPPORT_DOCUMENT]?.edit ?? false

  const canEditAdditionalSupportDocuments =
    offerPermissions[offerBookingGroupPolicyType.BOOKING_ADDITIONAL_SUPPORT_DOCUMENT]?.edit ?? false
  const canUploadBookingCostSheet = offerPermissions[offerBookingGroupPolicyType.BOOKING_COST_SHEET]?.edit ?? false
  const canUploadBookingConfirmationDocument =
    offerPermissions[offerBookingGroupPolicyType.BOOKING_CONFIRMATION_DOCUMENT]?.edit ?? false

  return (
    <>
      <Card
        title="Booking Documents"
        rightElement={
          canEditSupportDocuments && (
            <Button
              colorScheme="green"
              onClick={() => {
                addBookingSupportDocuments({ name: '', files: [] })
              }}
            >
              Add Support Documents
            </Button>
          )
        }
      >
        <VStack gap="3">
          <VersionFileInput
            label="Customer Confirmation Documents"
            name="booking.confirmationDocument"
            fileType={OfferBookingDocumentTypes.BOOKING_CONFIRMATION_DOCUMENT}
            canUpload={canUploadBookingConfirmationDocument}
            isRow
          />

          <Flex direction={'column'} w="100%" gap={1}>
            <Text fontWeight={'medium'} fontSize="md" mb="3">
              Booking Cost sheet (Excel Only)
            </Text>

            {subSystems &&
              subSystems.map((subSystem, index) => (
                <VersionFileInput
                  key={'bookingCostSheet_' + index}
                  label={`Subsystem ${index + 1}: ${subSystem.projectName}`}
                  name={`subSystems.${index}.bookingCostSheet`}
                  fileType={OfferBookingDocumentTypes.BOOKING_COSTSHEET}
                  canUpload={canUploadBookingCostSheet}
                  isRow
                  labelWidth={29}
                  isRequired={true}
                  allowedFileTypes={'.xlsm, .xlsx'}
                  ml="5"
                />
              ))}
          </Flex>

          {bookingSupportDocuments.map((other, index) => (
            <Flex key={other.id} w="100%">
              <HStack w="40%" mr="12px">
                <Input
                  name={`booking.supportDocuments.${index}.name`}
                  type="text"
                  disabled={!canEditSupportDocuments}
                />

                {canEditSupportDocuments && <CloseButton onClick={() => removeBookingSupportDocuments(index)} />}
              </HStack>

              <VersionFileInput
                name={`booking.supportDocuments.${index}.files`}
                fileType={OfferBookingDocumentTypes.BOOKING_SUPPORT_DOCUMENT}
                canUpload={canEditSupportDocuments}
                isRow
                labelWidth={40}
              />
            </Flex>
          ))}
        </VStack>
      </Card>
      {canEditAdditionalSupportDocuments && (
        <Card
          title="Additional Support Documents"
          rightElement={
            <Button
              colorScheme="green"
              onClick={() => {
                addNewAddedDocuments({ name: '', files: [] })
              }}
            >
              Add Documents
            </Button>
          }
        >
          <VStack gap="3">
            {newAddedDocuments.map((other, index) => (
              <Flex key={other.id} w="100%">
                <HStack w="40%" mr="12px">
                  <Input name={`booking.newSupportDocuments.${index}.name`} type="text" disabled={false} />
                  <CloseButton onClick={() => removeNewAddedDocuments(index)} />
                </HStack>

                <VersionFileInput
                  name={`booking.newSupportDocuments.${index}.files`}
                  fileType={OfferBookingDocumentTypes.BOOKING_NEW_SUPPORT_DOCUMENT}
                  canUpload={canEditAdditionalSupportDocuments}
                  isRow
                  labelWidth={40}
                />
              </Flex>
            ))}
          </VStack>
        </Card>
      )}
    </>
  )
}

export default BookingTabDocumentSection
